import React from "react";
import { NavLink } from "react-router-dom";
import "./Header.css";

const Header = () => {
  return (
    <header className="main-header">
      <div className="header-container">

        {/* LOGO */}
        <div className="logo">
          <NavLink to="/">
            <img src="/logo.png" alt="Nimbus BPO" />
          </NavLink>
        </div>

        {/* MENU */}
        <nav className="nav-menu">

          {/* SERVICES */}
          <div className="nav-item dropdown">
            <NavLink to="/service" className="nav-link">
              Services <span className="arrow">▾</span>
            </NavLink>

            <div className="dropdown-menu">
              <NavLink to="/service/inbound">Inbound Services</NavLink>
              <NavLink to="/service/outbound">Outbound Services</NavLink>
              <NavLink to="/service/voice-bot">Voice Bot</NavLink>
            </div>
          </div>

          {/* INDUSTRIES */}
          <div className="nav-item dropdown">
            <NavLink to="/industry" className="nav-link">
              Industries <span className="arrow">▾</span>
            </NavLink>

            <div className="dropdown-menu">
              <NavLink to="/industry/banking">Banking</NavLink>
              <NavLink to="/industry/healthcare">Healthcare</NavLink>
              <NavLink to="/industry/ecommerce">E-Commerce</NavLink>
            </div>
          </div>

          <NavLink className="nav-item" to="/clients">
            Clients
          </NavLink>

          <NavLink className="nav-item" to="/about">
            About Nimbus BPO
          </NavLink>
        </nav>

        {/* RIGHT SECTION */}
        <div className="header-right">
          <NavLink to="/career" className="career">
            <span className="briefcase">💼</span> Career
          </NavLink>

          <NavLink to="/get-quote">
            <button className="quote-btn">Get a Quote</button>
          </NavLink>
        </div>

      </div>
    </header>
  );
};

export default Header;
